// components/Auth/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/auth';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import styled from 'styled-components';

// Styled Components for Layout
const LoginPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Make it full viewport height */
  flex-direction: column; /* Arrange items vertically */
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px; /* Adjust width as needed */
`;

const Logo = styled.img`
  margin-bottom: 20px;
  max-width: 150px; /* Adjust logo size */
`;

const Title = styled.h1`
  margin-bottom: 20px; // Added margin to the title
  color: blue;
`;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await login(username, password);
	  localStorage.setItem('userName', username);
      localStorage.setItem('apiKey', data.api_key);
      localStorage.setItem('permissions', JSON.stringify(data.permissions));
      localStorage.setItem('loginTime', Date.now().toString());
      navigate('/sign');
    } catch (error) {
      console.error('Login failed', error);
      alert('Login failed. Please check your credentials.');
    }
  };

  return (
    <LoginPageContainer>
      <Logo src="/logo_digisign.png" alt="Logo" />
	  <Title>Fichaje Electronico</Title>
      <LoginForm onSubmit={handleSubmit}>
        <Input type="text" placeholder="Username/Correo electronico" value={username} onChange={(e) => setUsername(e.target.value)} />
        <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <Button type="submit">Login</Button>
      </LoginForm>
    </LoginPageContainer>
  );
};

export default Login;